module.exports = __webpack_public_path__ + "static/media/calendar.d561f838.svg";